import React, { Component } from 'react';
import classnames from 'classnames';

import Time from 'components/shared/text/Time';
import Button from 'components/shared/button/Button';
import ProjectOpenItemReview from 'components/admin/projects/details/project-daily-report-log/ProjectOpenItemReview';
import {
  setMemberForm,
  setEditMode,
} from 'components/admin/projects/details/project-daily-report-log/store/actions';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';

class ReviewFormForStaff extends Component {
  editMember = () => {
    this.props.dispatch(setMemberForm(true));
    this.props.dispatch(setEditMode(true));
    this.props.clearErrorOnStaff();
    this.props.clearErrorOnOpenItem();
  };

  membersToList = () => {
    const { members } = this.props;
    const membersToList = [];
    members.forEach((member) => {
      membersToList.push({
        ...member,
        isChildFloor: !!membersToList.find(
          (member2) => member2.user_id === member.user_id
        ),
      });
    });

    return membersToList;
  };

  renderMember = (member, child) => {
    return (
      <React.Fragment key={member.id}>
        {(member.floor || member.area) && (
          <p className="review-form-floor-title review-form-floor-title-staff">
            {member.floor && `Floor ${member.floor}`}
            {member.floor && member.area && ' - '}
            {member.area || ''}
          </p>
        )}
        <div key={member.id} className="review-form-content-wrapper">
          <div className="review-form-trade-block">
            <div className="review-form-title-block">
              <p className="review-form-block-title">
                <span>{`${member.user.first_name} ${member.user.last_name}`}</span>
                <span>Hours: {member.hours_worked || 0}</span>
                {member.started_at && (
                  <React.Fragment>
                    <span>Started at: </span>
                    <Time
                      className="review-form-date-span"
                      value={member.started_at}
                      format="LT"
                    />
                  </React.Fragment>
                )}
                {member.ended_at && (
                  <React.Fragment>
                    <span>Ended at: </span>
                    <Time
                      className="review-form-date-span"
                      value={member.ended_at}
                      format="LT"
                    />
                  </React.Fragment>
                )}
              </p>
              {!this.props.readOnly && !child && (
                <Button
                  className="button-orange"
                  label="Edit"
                  onClick={this.editMember}
                />
              )}
            </div>
          </div>
          {((member.supervisor_tasks && member.supervisor_tasks.length > 0) ||
            member.supervisor_task_other) && (
            <div className="review-form-trade-block">
              <p className="review-form-block-title">Tasks Performed</p>
              <div className="review-form-block-content">
                <ul>
                  {member.supervisor_tasks.length > 0 &&
                    member.supervisor_tasks.map((task) => (
                      <li key={task.id}>{task.label}</li>
                    ))}
                  {member.supervisor_task_other && (
                    <li>{member.supervisor_task_other}</li>
                  )}
                </ul>
              </div>
            </div>
          )}
          {member.comments && !this.props.readOnly && (
            <div className="review-form-trade-block">
              <p className="review-form-block-title">Comments</p>
              <div className="review-form-text-block">{member.comments}</div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  };

  render() {
    const {
      members,
      generalContactorLabel,
      openItem,
      errorsForStaff,
      errorsForOpenItem,
      images,
    } = this.props;
    const membersToList = members && members.length > 0 && this.membersToList();
    return (
      <div className="review-form-trade">
        <div className="review-form-trade-title">
          <p className="review-form-head-title">{generalContactorLabel}</p>
        </div>
        <div
          className={classnames({
            'review-form-staff-wrapper': true,
            'review-form-content-wrapper-error':
              !!errorsForStaff || !!errorsForOpenItem,
          })}
        >
          {members && members.length > 0 ? (
            membersToList
              .filter((member) => !member.isChildFloor)
              .map((member, index) => {
                return (
                  <React.Fragment key={index}>
                    {this.renderMember(member)}
                    {membersToList
                      .filter(
                        (member2) =>
                          member2.isChildFloor &&
                          member2.user_id === member.user_id
                      )
                      .map((member2) => this.renderMember(member2, true))}
                  </React.Fragment>
                );
              })
          ) : (
            <div className="review-form-content-wrapper">
              <div className="review-form-trade-block">
                <div className="review-form-title-block">
                  <p className="review-form-block-title">
                    <span>Staff Member</span>
                    <span>Hours: 0</span>
                  </p>
                  <Button
                    className="button-orange"
                    label="Edit"
                    onClick={this.editMember}
                  />
                </div>
              </div>
            </div>
          )}
          {images && images.length > 0 && (
            <div className="review-form-trade-block">
              <p className="review-form-block-title-photos">Photos</p>
              <div className="review-block-images-wrapper">
                <LogoUpload
                  readOnly
                  logos={images.map((image) => ({
                    preview: image.image.gallery.url,
                    url: image.image.url,
                  }))}
                />
              </div>
            </div>
          )}
          {openItem && <ProjectOpenItemReview openItem={openItem} />}
        </div>
      </div>
    );
  }
}

export default ReviewFormForStaff;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/ReviewFormForStaff.js